import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LogoDark } from '../components/Logo';
import Alert from '../components/Alert';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (!username.trim() || !password.trim()) {
      setError('Please enter both username and password.');
      return;
    }
    setLoading(true);
    try {
      await login(username.trim(), password);
      navigate('/dashboard');
    } catch (err) {
      setError(err?.response?.data?.error || 'Invalid username or password.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-screen">
      <div className="login-card">
        <div className="login-logo">
          <div className="login-logo-big" style={{ display: 'flex', justifyContent: 'center' }}>
            <LogoDark size={225} />
          </div>
          <div style={{ fontSize: 16, color: '#616161', marginTop: 5 }}>Smart Shopping, Every Day</div>
          <div style={{ marginTop: '.75rem', display: 'flex', justifyContent: 'center', gap: '1.5rem', fontSize: 15, color: '#888' }}>
            <span>🛒 Wholesale Prices</span>
            <span>⚡ Fast Delivery</span>
            <span>🏠 Delivered to Your Door</span>
          </div>
        </div>

        <Alert type="danger" message={error} onClose={() => setError('')} />

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Username</label>
            <input
              type="text"
              placeholder="Enter username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
            />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%', justifyContent: 'center', marginTop: '.5rem', padding: '.55rem' }}
            disabled={loading}
          >
            <i className="ti ti-login" aria-hidden="true"></i>
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
